/**
 * Aktif dernek.
 *
 * Bir kullanıcı birden fazla derneğe bağlı olabilir (ADR-1); hangisi adına
 * çalıştığı her istekte `X-Tenant-Slug` başlığıyla taşınır. Seçim tarayıcıda
 * saklanır ki sayfa yenilendiğinde kaybolmasın.
 *
 * Oturum ve kullanıcının gerçekten hangi derneklere yetkili olduğu YES-84 ile
 * gelecek; şu an seçim listesi tüm dernekleri gösteriyor.
 */
const STORAGE_KEY = 'akillidernek.tenant'

const listeners = new Set<() => void>()
let current: string | null = read()

function read(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    // Gizli sekmede ya da depolama kapalıyken erişim hata fırlatabilir.
    return null
  }
}

export function getTenantSlug(): string | null {
  return current
}

export function setTenantSlug(slug: string | null): void {
  current = slug
  try {
    if (slug) localStorage.setItem(STORAGE_KEY, slug)
    else localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Depolama yoksa seçim yalnızca bu sekmede yaşar; akış bozulmasın.
  }
  listeners.forEach((listener) => listener())
}

export function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
